import { render } from "./DataActions.vue?vue&type=template&id=f120261a"
import script from "./DataActions.vue?vue&type=script&lang=js"
export * from "./DataActions.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/DataForm/DataActions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f120261a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f120261a', __exports__)) {
    console.log('reload')
    api.reload('f120261a', __exports__)
  }
  
  module.hot.accept("./DataActions.vue?vue&type=template&id=f120261a", () => {
    console.log('re-render')
    api.rerender('f120261a', render)
  })

}


export default __exports__